import { render, staticRenderFns } from "./_filter_by_folder_id.vue?vue&type=template&id=2cd165cf&scoped=true&"
import script from "./_filter_by_folder_id.vue?vue&type=script&lang=js&"
export * from "./_filter_by_folder_id.vue?vue&type=script&lang=js&"
import style0 from "./_filter_by_folder_id.vue?vue&type=style&index=0&id=2cd165cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd165cf",
  null
  
)

export default component.exports